import gql from 'graphql-tag'

export default gql`query project_client_invoice($id: Int!) {
  project_client_invoice(id: $id){
    id
    invoice_number
    project{
      project_id
      name
      project_activity_budgets{
          id
          project_activity_type_id
          amount_to_invoice
          project_activity_type{
            description
          } 
          description
          address_id
          address{
            full_address
          }
          stage
          budget_label
          breakdown{
            id
            description
            amount
          }
        }
    }
    client{
      client_id
    }
    issued_at
    paid_at
    created_at
    invoice_url
    auto_generated
    breakdown{
      id
      description
      amount
      project_activity_budget_id
    }
  }
}`